// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.channel-expression-dialog-container .expression-actions .buttons button {
  min-width: 36px;
  width: 36px;
  height: 36px;
  font-size: 10px;
}
.channel-expression-dialog-container .expression-actions .channels {
  max-height: 250px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/unit-config/dialogs/channel-expression-dialog/channel-expression-dialog.component.scss"],"names":[],"mappings":"AAGG;EACC,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAFJ;AAME;EACC,iBAAA;AAJH","sourcesContent":[".channel-expression-dialog-container {\n\t.expression-actions {\n\t\t.buttons {\n\t\t\tbutton {\n\t\t\t\tmin-width: 36px;\n\t\t\t\twidth: 36px;\n\t\t\t\theight: 36px;\n\t\t\t\tfont-size: 10px;\n\t\t\t}\n\t\t}\n\n\t\t.channels {\n\t\t\tmax-height: 250px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
